var render = function render(){var _vm=this,_c=_vm._self._c;return _c('marker',{attrs:{"viewBox":`0 0 ${_vm.mw} ${_vm.mh}`,"refX":_vm.mw,"refY":_vm.mh/2,"markerWidth":_vm.mw,"markerHeight":_vm.mh,"orient":_vm.orient}},[_c('path',{style:(`fill: ${_vm.stroke}`),attrs:{"d":`M0,0 L0,${_vm.mh} L${_vm.mw},${_vm.mh/2} L0,0`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }